
export const pages = (page?: number, perPage?: number) => ({
  page: page || 1,
  perPage: perPage || 10,
})

export const sorts = (field?: string, order?: string) => ({
  field: field || 'id',
  order: order || 'ASC',
})
